<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ผู้อนุมัติลา</span>
    </div>
    <v-card outlined>
      <v-row align="center" class="ma-0">
        <v-col md="3" lg="3" xl="2">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            dense
            outlined
            hide-details
            placeholder="รหัส - ชื่อพนักงาน"
            @input="handleSearch"
          ></v-text-field>
        </v-col>
        <v-col md="3" lg="3" xl="2">
          <v-autocomplete
            v-model="filterOrganization"
            :items="organizations"
            item-text="title_th"
            item-value="organization_uuid"
            label="หน่วยงาน"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            @change="handleFilterOrganization"
          ></v-autocomplete>
        </v-col>
      </v-row>
    </v-card>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="leaveApprovers"
      :options.sync="options"
      :server-items-length="totalLeaveApprovers"
      :items-per-page="10"
      class="elevation-1 mt-3"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.name="{ item }">
        <div>{{ item.firstname_th }} {{ item.lastname_th }}</div>
      </template>
      <template v-slot:item.approver1="{ item }">
        <div v-if="item.approver_employee && item.approver_employee['1']">
          {{ item.approver_employee['1'].firstname_th }}
          {{ item.approver_employee['1'].lastname_th }}
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.approver2="{ item }">
        <div v-if="item.approver_employee && item.approver_employee['2']">
          {{ item.approver_employee['2'].firstname_th }}
          {{ item.approver_employee['2'].lastname_th }}
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.approver3="{ item }">
        <div v-if="item.approver_employee && item.approver_employee['3']">
          {{ item.approver_employee['3'].firstname_th }}
          {{ item.approver_employee['3'].lastname_th }}
        </div>
        <div v-else>-</div>
      </template>
    </v-data-table>
    <LeaveApproverForm
      :formShow="leaveApproverFormShow"
      :formAction="leaveApproverFormAction"
      :leaveApprover="leaveApprover"
      :leaveApproverInit="leaveApproverInit"
      @isLeaveApproverDataChange="handleLeaveApproverFormDataChange"
      @formActionCompleted="handleLeaveApproverFormActionCompleted"
      @onReset="handleLeaveApproverFormReset"
      @onChangeApproverEmployee="handleOnChangeApproverEmployee"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="leaveApproverFormShow && leaveApproverFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import LeaveApproverForm from '@/views/leave-approver/LeaveApproverForm.vue'

export default {
  components: {
    LeaveApproverForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      loading: false,
      sortBy: ['employee_code'],
      sortDesc: [false],
      search: '',
      options: {},
      headers: [
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          width: 140,
          class: 'text-no-wrap',
        },
        { text: 'ชื่อ - นามสกุล', value: 'name', class: 'text-no-wrap' },
        {
          text: 'หน่วยงาน',
          value: 'organization.title_th',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          text: 'ผู้อนุมัติคนที่ 1',
          value: 'approver1',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          text: 'ผู้อนุมัติคนที่ 2',
          value: 'approver2',
          sortable: false,
          class: 'text-no-wrap',
        },
        {
          text: 'ผู้อนุมัติคนที่ 3',
          value: 'approver3',
          sortable: false,
          class: 'text-no-wrap',
        },
      ],
      leaveApproverFormShow: false,
      leaveApproverFormAction: '',
      leaveApprover: {
        approver_employee: [],
      },
      leaveApproverInit: {
        approver_employee: [],
      },
      filterOrganization: null,
      isLeaveApproverDataChange: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
    }
  },
  watch: {
    options: {
      handler() {
        this.getLeaveApprovers()
      },
      deep: true,
    },
  },
  computed: {
    leaveApprovers() {
      return this.$store.state.leaveApprover.leaveApprovers.map(
        (leaveApprover) => {
          return {
            ...leaveApprover,
            approver_employee: leaveApprover.approver_employee
              ? this.convertArrayToObject(
                  leaveApprover.approver_employee,
                  'approver_level'
                )
              : null,
          }
        }
      )
    },
    totalLeaveApprovers() {
      return this.$store.state.leaveApprover.totalLeaveApprovers
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ผู้อนุมัติลา',
        disabled: true,
      },
    ])

    const { company_uuid } = this.$store.state.authentication.company

    const payload = {
      company_uuid,
      params: {
        dpc: 'employee-to-list-organization-no-filter',
        field: 'organization_uuid,organization_code,title_th',
      },
    }

    await this.fetchOrganizations(payload)
  },
  methods: {
    ...mapActions({
      fetchLeaveApprovers: 'leaveApprover/fetchLeaveApprovers',
      fetchLeaveApprover: 'leaveApprover/fetchLeaveApprover',
      fetchOrganizations: 'organization/fetchOrganizations',
    }),
    convertArrayToObject(array, key) {
      const initialValue = {}
      return array.reduce((obj, item) => {
        return {
          ...obj,
          [item[key]]: item,
        }
      }, initialValue)
    },
    handleOnChangeApproverEmployee({ type, approverEmployee }) {
      if (type === 'delete') {
        const approver_employee = this.leaveApprover.approver_employee
        delete approver_employee[approverEmployee.approver_level]
        this.leaveApprover = {
          ...this.leaveApprover,
          approver_employee: {
            ...approver_employee,
          },
        }

        return
      }

      if (type === 'edit') {
        const approver_employee = this.leaveApprover.approver_employee
        this.leaveApprover = {
          ...this.leaveApprover,
          approver_employee: {
            ...approver_employee,
            [approverEmployee.approver_level]: approverEmployee,
          },
        }

        return
      }
    },
    handleSearch() {
      this.loading = true
      this.getLeaveApproversBySearch()
    },
    handleFilterOrganization() {
      this.options.page = 1
      this.getLeaveApprovers()
    },
    getLeaveApproversBySearch: _.debounce(function () {
      this.options.page = 1
      this.getLeaveApprovers()
    }, 1000),
    getLeaveApprovers() {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      let sort = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'employee_code') sort = 'employee_code'
      if (sortByKey === 'name') sort = 'firstname_th'

      if (sortDesc.length > 0) {
        if (sortDesc[0]) {
          sort += `,desc`
        } else {
          sort += `,asc`
        }
      }

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: {
          dpc: 'leave-approver-to-list-leave-approver',
          search: this.search || undefined,
          organization_uuid: this.filterOrganization || undefined,
          is_active: true,
          sort,
          limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
        },
      }

      this.fetchLeaveApprovers(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    classRowSelected(row) {
      if (this.leaveApprover.employee_uuid === row.employee_uuid)
        return 'row-selected'
    },
    async setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::leave_approver:get')) {
        this.dialogForbidden = true
        return
      }

      try {
        await this.fetchLeaveApprover({
          company_uuid: this.$store.state.authentication.company.company_uuid,
          employee_uuid: row.employee_uuid,
        })
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      if (this.leaveApprover.employee_uuid === row.employee_uuid) {
        this.leaveApproverFormShow = false
        this.leaveApproverFormAction = ''
        this.leaveApprover = {
          approver_employee: [],
        }
        this.leaveApproverInit = {
          approver_employee: [],
        }
      } else {
        this.leaveApproverFormShow = true
        this.leaveApproverFormAction = ''
        this.leaveApprover = JSON.parse(JSON.stringify(row))
        this.leaveApproverInit = JSON.parse(JSON.stringify(row))
        // this.leaveApprover = {
        //   ...row,
        //   approver_employee: row.approver_employee
        //     ? [...row.approver_employee]
        //     : []
        // }
        // this.leaveApproverInit = {
        //   ...row,
        //   approver_employee: row.approver_employee
        //     ? [...row.approver_employee]
        //     : []
        // }
      }
    },
    handleRowSelected(row) {
      if (this.isLeaveApproverDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleLeaveApproverFormDataChange(value) {
      this.isLeaveApproverDataChange = value
    },
    handleLeaveApproverFormReset(formAction) {
      if (formAction === 'edit')
        this.leaveApprover = {
          ...this.leaveApproverInit,
          approver_employee: [...this.leaveApproverInit.approver_employee],
        }
    },
    handleLeaveApproverFormActionCompleted(formAction) {
      this.leaveApprover = {
        approver_employee: [],
      }
      this.leaveApproverInit = {
        approver_employee: [],
      }
      this.leaveApproverFormShow = false
      this.leaveApproverFormAction = ''
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.leaveApproverFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isLeaveApproverDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
